<template>
  <div class="resetPassword">
    <Row>
      <Col span="24" class-name="form-title">重置密码</Col>
    </Row>
    <Form ref="changeFormValidate" :model="changeFormValidate" :rules="changeRuleValidate">
      <Row class="password-input">
        <Col span="24">
          <FormItem prop="changePassword">
            <Input v-model="changeFormValidate.changePassword" :disabled="isDisable" placeholder="请输入新密码" type="password" :maxlength="16"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row class="password-input">
        <Col span="24">
          <FormItem prop="changePasswordCheck">
            <Input v-model="changeFormValidate.changePasswordCheck" :disabled="isDisable" placeholder="请再次输入新密码" type="password" :maxlength="16"></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Row >
      <Col span="24" style="height: 100px">
        <Button type="primary" long style="height:42px;margin-top:50px" @click="doChangeConfirm" :disabled="isDisable" v-if="okShow">确定</Button>
        <Button long style="height:42px;margin-top:50px" v-if="!okShow" disabled>密码修改中</Button>
      </Col>
      <!-- <Col span="24" class-name="form-tip">密码重置后，颐海OA、邮箱、VPN、CRM、追溯系统密码会同步变更</Col> -->
      <Col span="24" class-name="form-tip">{{ message }}</Col>
      <Col span="24" v-if="isDisable" class="tip-error">对不起, 您无权限操作</Col>
    </Row>
  </div>
</template>
<script>
import { Validation } from '@/libs/util'
export default {
  name: 'resetPassword',
  data () {
    // 修改密码-确认密码
    const validateChangePassCheck = (rule, value, callback) => {
      if (value !== this.changeFormValidate.changePassword) {
        callback(new Error('密码不一致'))
      } else {
        callback()
      }
    }
    return {
      baseUrl: `${window.document.location.origin}/`,
      isDisable: false,
      okShow: true,
      userCode: null,
      oldPassword: '',
      message: '',
      changeRuleValidate: {
        changePassword: [
          { validator: Validation.userPassword, trigger: 'blur' }
        ],
        changePasswordCheck: [
          { validator: validateChangePassCheck, trigger: 'blur' }
        ]
      },
      // 修改密码参数
      changeFormValidate: {
        changePassword: '',
        changePasswordCheck: ''
      }
    }
  },
  created () {
    if (this.$route.query.code) {
      this.doGetUserInfo(this.$route.query.code)
    } else {
      this.isDisable = true
    }
  },
  methods: {
    // 获取账户信息
    doGetUserInfo (code) {
      this.$request.post(`${this.baseUrl}/sso/wechat/getUserIdByAuthorize`, { code: code }).then(res => {
        this.userCode = res.data
        // 获取提示信息
        this.doGetMessage()
      })
    },
    doGetMessage () {
      this.$request.post(`${this.baseUrl}/sso/user/userInfoForWxRestPwd`, { userCode: this.userCode }).then(res => {
        if (res.data.code === 'OK') {
          this.message = res.data.data.message
          this.oldPassword = res.data.data.password
        }
      })
    },
    doChangeConfirm () {
      this.okShow = false
      this.$refs['changeFormValidate'].validate((valid) => {
        if (valid) {
          let req = {
            userCode: this.userCode,
            password: this.changeFormValidate.changePassword
          }
          if (req.password === this.oldPassword) {
            this.$Modal.error({
              title: '抱歉，新密码不能与原密码一致'
            })
          } else {
            this.doUpdatePassword(req)
          }
        }
      })
    },
    doUpdatePassword (data) {
      this.$request.post(`${this.baseUrl}/sso/user/wxResetPassword`, data).then(res => {
        if (res.data.code === 'OK') {
          this.$Modal.success({
            title: '密码修改成功'
          })
        } else {
          this.$Modal.error({
            title: '密码修改失败'
          })
        }
        this.okShow = true
        this.$refs['changeFormValidate'].resetFields()
      })
    }
  }
}
</script>
<style lang="less">
.resetPassword{
  background: white;
  padding: 0 10%;
  .form-title{
    font-size: 24px;
    line-height: 3;
    font-weight: 800;
    color: #C82A1E;
    position: relative;
    text-align: center;
    margin-bottom: 80px;
    margin-top: 40px;
  }
  .tip-error{
    color: #C82A1E;
    font-size: 24px;
    text-align: center;
  }
}
.form-tip{
  font-size: 14px;
  padding-top: 30px;
  // text-align: center;
  color: #C82A1E;
}
.password-input{
  .ivu-input{
    height: 42px;
  }
}
</style>
